import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../context/StoreContext';
import TemplateClassic from '../templates/TemplateClassic';
import TemplateFashion from '../templates/TemplateFashion';
import TemplateHandmade from '../templates/TemplateHandmade';
import TemplateFood from '../templates/TemplateFood';
import TemplateTech from '../templates/TemplateTech';

const TEMPLATE_MAP = {
  classic: TemplateClassic,
  fashion: TemplateFashion,
  handmade: TemplateHandmade,
  food: TemplateFood,
  tech: TemplateTech,
};

const Home = () => {
  const { t } = useTranslation('common');
  const { templateId } = useStore();
  const Template = TEMPLATE_MAP[templateId] || TemplateClassic;
  return <Template />;
};

export default Home;
